import React from "react";
import ErrorState from "./ErrorState";

// Catches render crashes so one broken page shows a recovery panel instead of a blank screen.
// `resetKey` (the current path) clears the error when the user navigates elsewhere.
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorState
          title="Something went wrong"
          message="This page hit an unexpected error. Try again, or reload if it keeps happening."
          onRetry={() => this.setState({ hasError: false })}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
